export default __webpack_public_path__ + "static/media/79.ad9f2d67.jpg";